import { useEffect, useState } from "react";
import { DataGrid, gridClasses } from '@mui/x-data-grid';
import { Box, IconButton, Typography, Paper, TextField } from "@mui/material";
import { FilterAlt } from "@mui/icons-material";
import { renderUserCell } from "./renderUserCell";
import { CustomToolbar } from "./CustomToolbar";

const playersDataFromBackend = [
    { id: 1, name: 'Fadi Hareth', username: 'Fadi_New', birthYear: 2000, battingHand: 'RHB', throwingHand: 'RHT', position1: 'Center Field', position2: 'Right Field', position3: '', batBrand: 'LouisVille Slugger', gloveBrand: 'Shoeless Joe', cleatBrand: '', battingGloveBrand: '' },
    { id: 2, name: 'Blake Stone', username: 'BlakeStone', birthYear: 1990, battingHand: 'RHB', throwingHand: 'LHT', position1: 'Center Field', position2: 'Left Field', position3: 'Right Field', batBrand: '', gloveBrand: 'Rawlings', cleatBrand: 'Nike', battingGloveBrand: 'Franklin' },
    { id: 3, name: 'Real Guy', username: 'TheRealest', birthYear: 1999, battingHand: 'LHB', throwingHand: 'LHT', position1: '1st Base', position2: '2nd Base', position3: 'Catcher', batBrand: 'Mizuno', gloveBrand: 'Wilson', cleatBrand: 'Adidas', battingGloveBrand: 'Easton' },
    { id: 4, name: 'Longest Options', username: 'LoooongUsername', birthYear: 1964, battingHand: 'RHB', throwingHand: 'RHT', position1: 'Center Field', position2: 'Right Field', position3: 'Shortstop', batBrand: 'LouisVille Slugger', gloveBrand: 'LouisVille Slugger', cleatBrand: 'Under Armour', battingGloveBrand: 'LouisVille Slugger' },
    { id: 5, name: 'No Info', username: '', birthYear: null, battingHand: '', throwingHand: '', position1: '', position2: '', position3: '', batBrand: '', gloveBrand: '', cleatBrand: '', battingGloveBrand: '' },
];

const Search = () => {
    const [playersData, setPlayersData] = useState(playersDataFromBackend);
    const [searchText, setSearchText] = useState("");

    useEffect(() => {
        if (searchText === "") {
            setPlayersData(playersDataFromBackend);
        } else {
            setPlayersData(playersDataFromBackend.filter((player) => {
                return Object.values(player).some((s) => {
                    return String(s).toLowerCase().includes(searchText.toLowerCase())
                })
            }))
        }
    }, [searchText])

    const ageGetter = ({ birthYear }) => {
        if (birthYear === null) {
            return null;
        }
        return new Date().getFullYear() - birthYear;
    };

    const positionsGetter = ({ position1, position2, position3 }) => {
        var positions = [position1, position2, position3].filter((position) => position !== '');
        return positions.join(', ');
    };

    const columns = [
        { 
            field: 'name',
            headerName: 'User',
            width: 200,
            renderCell: renderUserCell
        },
        { 
            field: 'age',
            headerName: 'Age',
            type: 'number',
            width: 100,
            valueGetter: (value, row) => ageGetter(row),
        },
        { field: 'battingHand', headerName: 'Bat', width: 100 },
        { field: 'throwingHand', headerName: 'Throw', width: 100 },
        { 
            field: 'positions',
            headerName: 'Positions Played',
            width: 240,
            valueGetter: (value, row) => positionsGetter(row),
        },
        { field: 'batBrand', headerName: 'Bat Brand', width: 180 },
        { field: 'gloveBrand', headerName: 'Glove Brand', width: 180 },
        { field: 'cleatBrand', headerName: 'Cleat Brand', width: 180 },
        { field: 'battingGloveBrand', headerName: 'Batting Glove Brand', flex: 1 },
    ];

    const paginationModel = { page: 0, pageSize: 25 };

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'left',
                gap: 3,
                margin: 3
            }}
        >
            <Box display="flex" justifyContent="space-between" sx={{ alignItems: "end" }}>
                <Typography variant="h5">Search Players</Typography>
            </Box>
            <Box display="flex" width={"100%"} gap={2} sx={{ alignItems: "center" }}>
                <IconButton><FilterAlt /></IconButton>
                <TextField label="Search all columns" value={searchText} onChange={(e) => setSearchText(e.target.value)} />
            </Box>
            <Paper sx={{ display: 'flex', width: 1525 }}>
                <DataGrid
                    rows={playersData}
                    columns={columns}
                    initialState={{ pagination: { paginationModel } }}
                    checkboxSelection
                    disableColumnResize
                    disableColumnMenu
                    slots={{ toolbar: CustomToolbar }}
                    getRowHeight={() => 'auto'}
                    sx={{
                        [`& .${gridClasses.cell}`]: {
                          py: 1,
                        },
                        border: 0,
                    }}
                />
            </Paper>
        </Box>
    );
}

export default Search;
